import { render, staticRenderFns } from "./quote-refer-info.vue?vue&type=template&id=088a8ba1&scoped=true&"
import script from "./quote-refer-info.vue?vue&type=script&lang=js&"
export * from "./quote-refer-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088a8ba1",
  null
  
)

export default component.exports